import React from 'react';
import { Grid, TextField } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Controller } from 'react-hook-form';
import AccordionCard from '../../../Shared/Components/AccordionCard/AccordionCard';
import type { InvoiceSellerSectionProps } from './InvoiceSellerSection.types';

const InvoiceSellerSection: React.FC<InvoiceSellerSectionProps> = ({ control, errors }) => {
  return (
    <AccordionCard title="Sprzedawca" icon={<InfoIcon color="primary" />}>
      <Grid container spacing={2}>
        {/* N A Z W A   S P R Z E D A W C Y */}
        <Grid size={{ xs: 12, md: 6 }} >
          <Controller
            name="sellerName"
            control={control}
            render={({ field }) => (
              <TextField
                label="Sprzedawca – nazwa"
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                fullWidth
                error={!!errors.sellerName}
                helperText={errors.sellerName?.message as string | undefined}
              />
            )}
          />
        </Grid>

        {/* U L I C A   I   N U M E R */}
        <Grid size={{ xs: 12, md: 4 }} >
          <Controller
            name="sellerStreetNo"
            control={control}
            render={({ field }) => (
              <TextField
                label="Sprzedawca – ulica i numer"
                placeholder="np. Jaśminowa 33 m. 4"
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                fullWidth
                error={!!errors.sellerStreetNo}
                helperText={errors.sellerStreetNo?.message as string | undefined}
              />
            )}
          />
        </Grid>

        {/* N I P */}
        <Grid size={{ xs: 12, md: 2 }} >
          <Controller
            name="sellerNip"
            control={control}
            render={({ field }) => (
              <TextField
                label="NIP sprzedawcy"
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                fullWidth
                error={!!errors.sellerNip}
                helperText={errors.sellerNip?.message as string | undefined}
              />
            )}
          />
        </Grid>

        {/* P O Z O S T A Ł Y   A D R E S */}
        <Grid size={{ xs: 12, md: 6 }} >
          <Controller
            name="sellerAddress"
            control={control}
            render={({ field }) => (
              <TextField
                label="Sprzedawca – pozostały adres (kod, miasto)"
                placeholder="np. 25-000 Kielce"
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                fullWidth
                error={!!errors.sellerAddress}
                helperText={errors.sellerAddress?.message as string | undefined}
              />
            )}
          />
        </Grid>
      </Grid>
    </AccordionCard>
  );
};

export default InvoiceSellerSection;
